import { Component, Input} from '@angular/core'

import { ActionBarComponent } from '../action-bar/action-bar.component'
import { animate, style, transition, trigger } from '@angular/animations'
import { QuestionAndAnswer, StatusMessage} from '../../../../types'
import { CommonModule } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'
import { LoaderComponent } from '../../../loader/loader.component'

@Component({
   selector: 'app-status-message',
   standalone: true,
   imports: [CommonModule, LoaderComponent, ActionBarComponent, TranslocoModule],
   templateUrl: './status-message.component.html',
   styles: '',
   animations: [
      trigger('fadeIn', [
         transition(':enter', [
            style({ opacity: 0.2 }),
            animate('200ms ease-in', style({ opacity: 1 })),
         ])
      ])
   ]
})
export class StatusMessageComponent  {
   @Input() qanda!: QuestionAndAnswer
   @Input() status!: StatusMessage
   @Input() shouldShowLoader!: boolean


   constructor() {

   }

}

